<style lang="scss" scoped>
@import "./8_yykh.css";
@import "./8_yykhmin.css";
</style>
<style lang="scss">
.banquan{
    padding: 20px 19rem;
    position: absolute;
    width: 100%;
    background: #016974;
    left: 0;
    line-height: 5px;
    color: #ffffff;
}
.banquanIpad{
   padding: 20px 1rem;
    position: absolute;
    width: 100%;
    background: #016974;
    left: 0;
    line-height: 5px;
    color: #ffffff;
}
#oBody .el-form-item{
  margin-bottom:0 !important
}
#oBody .subBtn{
  width:15rem;
}
#o8_yykh {
  .el-form-item__error{
    left:-23px;
    margin-top: 8px;
  }
  .borderTop{
    border: 1px solid #e5e5e5;
    border-radius: 0 0 5px 5px;
    margin-bottom: 30px;
  }
  .warp-logo {
    width: 1.1rem;
    position: relative;
    top: 0.2rem;
  }
  .el-picker-panel-calendar{
    border: none;
  }
  .el-table--border-calendar{
    border-left: none;
    border-right: none;
  }
  .warp-logo1 {
    width: 1.1rem;
    position: relative;
    top: 0.2rem;
  }
  .formTitles{
    font-size: 0.9rem !important;
    color: #ffffff;
    background: #25b0b6;
    border-radius: 5px 5px 0 0;
    padding: 10px 0;
  }
  #warp_low {
    .el-col-offset-2 {
      margin-left: 2.33333%;
    }
    .tjBtn {
      background-color: #26b1b7;
      color: #fff;
      border: none;
      cursor: pointer;
      border-radius: 0.3rem;
      font-size: 0.8rem;
      height: 2rem;
      width: 118%;
      outline: none;
    }

    .el-form-item {
      margin-right: 0 !important;
    }

    .el-form-item__content {
      width: calc(100%) !important;
    }
  }

  #warp_phone {
    margin-right: 0 !important;

    .el-form-item__content {
      width: calc(100%) !important;
    }
  }

  #warp_name {
    margin-right: 0 !important;

    .el-form-item__content {
      width: calc(100%) !important;
    }
  }

  // .En_lang {
  .el-form-item__label {
    width: calc(100%) !important;
    // 150px !important;
  }
  // }
}

#warp_input {
  border-color: #c0c4cc !important;
}

#o8_yykhmin {
  .el-form-item__error{
     left:-7px;
    margin-top: 10px;
  }
  .borderTop{
    border: 1px solid #e5e5e5;
    border-radius: 0 0 5px 5px;
    margin-bottom: 30px;
  }
    .el-picker-panel-calendar{
    border: none;
  }
  .el-table--border-calendar{
    border-left: none;
    border-right: none;
  }
  .warp-logo {
    width: 1.5rem;
    position: relative;
    top: 0.2rem;
  }
  .warp-logo1 {
    width: 1.5rem;
    position: relative;
    top: 0.2rem;
  }
  .formTitles {
    font-size: 1.1rem !important;
    color: #ffffff;
    background: #25b0b6;
    border-radius: 5px 5px 0 0;
    padding: 10px 0;
  }
  #warp_low {
    .el-col-offset-2 {
      margin-left: 2.33333%;
    }

    .tjBtn {
      background-color: #26b1b7;
      color: #fff;
      border: none;
      cursor: pointer;
      border-radius: 0.3rem;
      font-size: 0.95rem;
      height: 3rem;
      line-height: 3rem;
      width: 118%;
      outline: none;
    }

    .el-form-item {
      margin-right: 0 !important;
    }

    .el-form-item__content {
      width: calc(100%) !important;
    }
  }

  #warp_phone {
    margin-right: 0 !important;

    .el-form-item__content {
      width: calc(100%) !important;
    }
  }

  #warp_name {
    margin-right: 0 !important;

    .el-form-item__content {
      width: calc(100%) !important;
    }
  }

  // .En_lang {
  .el-form-item__label {
    width: calc(100%) !important;
  }
  // }
}
</style>
<template>
  <div :id="websta == 'pc' || websta == 'ipad' ? 'o8_yykh' : 'o8_yykhmin'" style="overflow: hidden; margin-top: 20px" >
    <div class="ListView" style="padding:1rem" :style="websta == 'ipad' ? 'margin-top: 0;margin-bottom:30px;' : websta == 'phone'?'': 'margin-bottom:30px;'">
      <!-- <div class="formTitle" v-if="websta == 'pc'">
			{{this.$t('ktzh.type2')}}</div>  v-else-->
      <div class="formTitles" :style="websta == 'pc' || websta == 'ipad'?'padding-left: 25px;':'padding-left: 10px;'">
        <!-- <img :src="gettime" alt="" class="warp-logo" /> -->
        {{ this.$t("ktzh.type2") }}
      </div>
      <!-- <div class="time-warning" v-if="websta == 'pc'|| websta == 'ipad'">
				<div class="common left"><img src="../../image/icon_yiwen.png"> {{this.$t('ktzh.warning_left')}}</div>
				<div class="common right"><img src="../../image/icon_hk.png"> {{this.$t('ktzh.warning_right')}}
					<div class="red-circle"></div>
				</div>
			</div>  v-else-->
      <div class="time-warning" :style="islang ? '' : 'display:flex'">
        <div class="common left">
          <img src="../../image/icon_yiwen.png" />
          {{ this.$t("ktzh.warning_left") }}
        </div>
        <div class="common right">
          <img src="../../image/icon_hk.png" />
          {{ this.$t("ktzh.warning_right") }}
          <!-- <div class="red-circle"></div> -->
        </div>
      </div>
      <div class="borderTop">
        <ele-calendar
          :defaultValue="datetime"
          :render-content="renderContent"
          :data="datedef"
          :lang="$i18n.locale == 'eng' ? 'en' : 'zh-CN'"
          :prop="prop"
          :border="true"
          @pick="dateselect"
          :disabledDate="disabledDate"
        >
        </ele-calendar>
        <div :style="websta == 'pc' || websta == 'ipad'?'margin: 0 auto;padding: 0 25px;':'margin: 0 auto;padding: 0 10px;'">
          <el-form
            ref="form2"
            :model="form1"
            label-width="90px"
            size="small"
            :inline="true"
            :hide-required-asterisk="true"
          >
            <el-form-item
              class="inerror"
              prop="yuyuetime"
              :rules="[
                {
                  required: true,
                  message: this.$t('ktzh.qxzyysj'),
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <div class="buttomView var_kFFF" v-for="(item, index) in timeList"
                :style="{
                  textAlign: Object.is(index % 3, 0)
                    ? 'left'
                    : index % 3 == 1
                    ? 'center'
                    : index % 3 == 2
                    ? 'right'
                    : '',
                }"
                :key="item.key"
              >
                <el-button
                  :value="item.time"
                  :itemprop="index"
                  :class="[
                    item.state == 0 ? 'kx' : 'xx',
                    item.time == form1.yuyuetime ? 'tim2' : 'tim',
                  ]"
                  @click="
                    item.state == 0 ? kx(item.time) : xx(item.time, item.state)
                  "
                >
                  <div style="color: #fff">
                    <i
                      :class="
                        item.state == 0
                          ? 'el-icon-s-custom warp_icon'
                          : 'el-icon-coffee-cup warp_icon'
                      "
                    ></i
                    >{{ item.time }}
                  </div>
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
        <!-- 英文 -->
      <div v-if="true || islang">
        <el-form
          ref="form1"
          label-position="top"
          :model="form1"
          :rules="rules"
          :hide-required-asterisk="true"
        >
          <div
            class="ListView chStyle"
            style="padding: 0;border: 1px solid #e5e5e5;border-radius: 5px;"
            :class="islang ? 'En_lang' : ''"
          >
            <!-- <div class="formTitle" v-if="websta == 'pc'">{{this.$t('tabbar.jbxx')}}</div>  v-else-->
            <div class="formTitles" :style="websta == 'pc' || websta == 'ipad'?'padding-left: 25px;':'padding-left: 10px;'">
              <!-- <img :src="getuse" alt="" class="warp-logo1" />      -->
              {{ this.$t("tabbar.jbxx") }}
            </div>
            <el-row :style="websta == 'pc' || websta == 'ipad'?'padding: 0 25px;margin-top: 10px;':'padding: 0 10px;'">
              <el-col :sm="24" :lg="11" :style="websta == 'phone' ? 'margin-top:10px;': ''">
                <el-form-item
                  :label="islang ? $t('jbxx.ywxm') : $t('jbxx.zwxm')"
                  prop="name"
                  id="warp_name"
                  v-if="islang"
                >
                  <el-input
                    v-model="form1.name"
                    @input="checkForm(form1.name, 'En_name')"
                    :placeholder="
                      islang
                        ? $t('jbxx.qshruyingwenming')
                        : $t('jbxx.qshurzhongwenm')
                    "
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  :label="islang ? $t('jbxx.ywxm') : $t('jbxx.zwxm')"
                  prop="name"
                  id="warp_name"
                  v-else
                >
                  <el-input
                    v-model="form1.name"
                    @input="checkForm(form1.name, 'Cn_name')"
                    :placeholder="
                      islang
                        ? $t('jbxx.qshruyingwenming')
                        : $t('jbxx.qshurzhongwenm')
                    "
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="{ span: 11, offset: 2 }" :style="websta == 'phone' ? 'margin-top:15px;': ''">
                <el-form-item
                  :label="$t('khlx.dydz')"
                  prop="email"
                  id="warp_phone"
                >
                  <el-input
                    v-model="form1.email"
                    :placeholder="$t('khlx.dydzinput')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row id="warp_low" :style="websta == 'pc' || websta == 'ipad'?'padding: 0 25px; margin: 10px 0 20px;':'padding: 0 10px;margin-bottom: 10px;'">
              <el-col :sm="24" :lg="11" :style="websta == 'phone' ? 'margin-top:15px;': ''">
                <el-form-item :label="$t('login.telephone')" prop="phone">
                  <!-- this.$t('sgzk.qsrsgsj') -->
                  <el-row>
                    <el-col :span="7">
                      <el-select v-model="form1.nationcode" id="warp_input">
                        <el-option
                          v-for="item in qhArr"
                          :key="item.id"
                          :label="'+ ' + item.value"
                          :value="item.value"
                        >
                          <span style="font-size: 0.8rem; float: left">{{
                            item.label
                          }}</span>
                          <span style="font-size: 0.8rem; float: right"
                            >+{{ item.value }}</span
                          >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="10" :offset="2">
                      <el-input
                        :maxlength="form1.nationcode=='852'?'8':'11'"
                        v-model="form1.phone"
                        :placeholder="
                          websta == 'pc'
                            ? $t('login.plaletelephoneweb')
                            : $t('login.plaletelephones')
                        "
                      >
                      </el-input>
                    </el-col>
                    <el-col :span="5" :offset="2">
                      <button type="button" class="tjBtn" @click="codeFn">
                        {{ form1.codeIndex }}
                      </button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="{ span: 11, offset: 2 }" :style="websta == 'phone' ? 'margin-top:15px;': ''"> 
                <el-form-item
                  :label="$t('login.verificationcode')"
                  prop="captcha"
                >
                  <el-input
                    v-model="form1.captcha"
                    :placeholder="this.$t('login.vcodeinput')"
                    maxlength="6"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <!-- 中文 -->
      <div v-else>
        <el-form
          ref="form1"
          label-position="top"
          :model="form1"
          label-width="5.6rem"
          size="small"
          :inline="true"
          :rules="rules"
          :hide-required-asterisk="true"
        >
          <!-- :label-position="islang?'top':'left'" -->
          <div
            class="ListView chStyle"
            style="padding: 0;border: 1px solid #e5e5e5;border-radius: 5px;"
            :class="islang ? 'En_lang' : ''"
          >
            <div class="formTitle">{{ this.$t("tabbar.jbxx") }}</div>
            <el-row :style="websta == 'pc' || websta == 'ipad'?'padding: 0 25px;':''">
              <el-col :sm="24" :lg="11" class="cnLabel" :style="websta == 'phone' ? 'margin-top:10px;': ''">
                <el-form-item
                  :label="islang ? $t('jbxx.ywxm') : $t('jbxx.zwxm')"
                  prop="name"
                  id="warp_name"
                >
                  <el-input
                    v-model="form1.name"
                    @input="checkForm(form1.name, 'Cn_name')"
                    :placeholder="
                      islang
                        ? $t('jbxx.qshruyingwenming')
                        : $t('jbxx.qshurzhongwenm')
                    "
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="{ span: 11, offset: 2 }" class="cnLabel" :style="websta == 'phone' ? 'margin-top:15px;': ''">
                <el-form-item
                  :label="$t('khlx.dydz')"
                  prop="email"
                  id="warp_phone"
                >
                  <el-input
                    v-model="form1.email"
                    :placeholder="$t('khlx.dydzinput')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row id="warp_low" :style="websta == 'pc' || websta == 'ipad'?'padding: 0 25px;':''">
              <el-col :sm="24" :lg="11" class="cnLabel" :style="websta == 'phone' ? 'margin-top:15px;': ''">
                <el-form-item :label="$t('login.telephone')" prop="phone">
                  <!-- this.$t('sgzk.qsrsgsj') -->
                  <el-row>
                    <el-col :span="7">
                      <el-select v-model="form1.nationcode" id="warp_input">
                        <el-option
                          v-for="item in qhArr"
                          :key="item.id"
                          :label="'+ ' + item.value"
                          :value="item.value"
                        >
                          <span style="font-size: 0.8rem; float: left">{{
                            item.label
                          }}</span>
                          <span style="font-size: 0.8rem; float: right"
                            >+{{ item.value }}</span
                          >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="10" :offset="2">
                      <el-input
                        v-model="form1.phone"
                        :placeholder="this.$t('login.plaletelephone')"
                        :maxlength="form1.nationcode=='852'?'8':'11'"
                      >
                      </el-input>
                    </el-col>
                    <el-col :span="5" :offset="2">
                      <button type="button" class="tjBtn" @click="codeFn">
                        {{ form1.codeIndex }}
                      </button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="{ span: 11, offset: 2 }" class="cnLabel" :style="websta == 'phone' ? 'margin-top:15px;': ''">
                <el-form-item
                  :label="$t('login.verificationcode')"
                  prop="captcha"
                >
                  <el-input
                    v-model="form1.captcha"
                    :placeholder="this.$t('login.vcodeinput')"
                    maxlength="6"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <button type="button" class="subBtn" style="border-radius:0.3rem" @click="nextFn">
        {{ $t("login.submits") }}
      </button>
    </div>
    <div class="banquan" v-if="websta == 'pc'">{{ $t("login.copyright") }}</div>
    <div class="banquanIpad" v-else-if="websta == 'ipad'">{{ $t("login.copyright") }}</div>
    <div class="banquanIpad" style="line-height: normal;" v-else>{{ $t("login.copyright") }}</div>
    <Messwarn ref="Messwarn"></Messwarn>
  </div>
</template>
<style lang="scss">
.var_kFFF {
  .el-icon-s-custom {
    color: #fff !important;
  }

  .el-icon-coffee-cup {
    color: #fff !important;
  }

  .el-button {
    span {
      color: #fff !important;
    }
  }
}
</style>
<script>
import https from "@/plugins/http.js";

import apiUrl from "@/assets/api.js";

import App from "@/assets/app.js";

import eleCalendar from "ele-calendar";

import "ele-calendar/dist/vue-calendar.css";

export default {
  name: "Officialwebsite",
  components: {
    eleCalendar,
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      let patrn = /^\S+@\S+\.\S{2,}$/;
      if (value === "") {
        // callback(new Error(this.$t('khlx.dydzinput')));
        callback(new Error(" "));
      } else if (!patrn.exec(value)) {
        // callback(new Error(this.$t('khlx.errordydzinput')));
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      gettime: require("@/image/gettime.png"),
      getuse: require("@/image/getuse.png"),
      websta: sessionStorage["onlinestate"],
      islang: this.$i18n.locale == "eng",
      // 手機區號列表
      qhArr: [
        {
          id: "1",
          value: "86",
          label: this.$t("login.zgdl"),
        },
        {
          id: "2",
          value: "852",
          label: this.$t("login.zgxg"),
        },
        {
          id: "3",
          value: "853",
          label: this.$t("login.zgam"),
        },
        {
          id: "4",
          value: "61",
          label: this.$t("login.adly"),
        },
        {
          id: "5",
          value: "1",
          label: this.$t("login.jnd"),
        },
        {
          id: "6",
          value: "60",
          label: this.$t("login.mlxy"),
        },
        {
          id: "7",
          value: "1",
          label: this.$t("login.mg"),
        },
        {
          id: "8",
          value: "65",
          label: this.$t("login.xjp"),
        },
        {
          id: "9",
          value: "64",
          label: this.$t("login.xxl"),
        },
        {
          id: "10",
          value: "44",
          label: this.$t("login.yg"),
        },
      ],
      datedef: [],
      prop: "date",
      aa: [],
      timeList: {},
      form1: {
        yuyuetime: null,
        nationcode: "86",
        codeIndex: this.$t("login.yanzhengma"),
        phone: "",
        captcha: "",
        name: "",
      },
      jiejiari: [
      '2022-01-01', '2022-02-01', '2022-02-02', '2022-02-03', '2022-04-05', '2022-04-15', '2022-04-16', '2022-04-18', '2022-05-02', '2022-05-09', '2022-06-03', '2022-07-01', '2022-09-12', '2022-10-01', '2022-10-04', '2022-12-26', '2022-12-27', '2023-01-01', '2023-01-02', '2023-01-03', '2023-01-04', '2023-01-05', '2023-04-18', '2023-05-02', '2023-05-09', '2023-06-03', '2023-07-01', '2023-09-12', '2023-10-04', '2023-12-26', '2023-12-27'
      ],
      rules: {
        email: [
          // {required: true,message: this.$t('khlx.dydzinput'),trigger: ['blur', 'change']},
          {
            validator: validateEmail,
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: " ",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: " ",
            trigger: ["blur", "change"],
          },
        ],
        captcha: [
          {
            required: true,
            message: " ",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    // jiejiari: {
    //     handler(nv,old) {
    //       debugger
    //       this.jiejiari = nv
    //       console.log(this.jiejiari);
    //     },
    //     deep: true,
    //     immediate: true,
    // },
  },
  beforeCreate() {
    https.fetchLoginPost(apiUrl.getHolidayList,{
    }).then((data) => {
        if(Object.is(data.qmiscode,1000)){
          this.jiejiari = data.holidaylist
          console.log(this.jiejiari);
        }
    }).catch(err => {
        console.log(err);
    });
    let _this = this;
    function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          if (localStorage.lang !== pair[1]) {
            if (pair[1]) {
              _this.$i18n.locale = pair[1];
              localStorage.setItem("lang", pair[1]);
            }
            // location.reload();
          }
        }
      }
      return false;
    }
    getQueryVariable("lang");
  },
  created() {
    if (this.datetime == null || this.datetime.trim().length <= 0) {
      var myDate = new Date();
      myDate.setDate(myDate.getDate() + 1);
      while (
        myDate.getDay() == 0 ||
        myDate.getDay() == 6 ||
        this.jiejiari.indexOf(
          myDate.getFullYear() +
            "-" +
            (myDate.getMonth() + 1) +
            "-" +
            myDate.getDate()
        ) >= 0
      ) {
        myDate.setDate(myDate.getDate() + 1);
      }
      this.datetime = myDate;
      this.aa.push(myDate);
      console.log(this.aa, this.datetime);
    }
    this.messLoad();
    
  },
  mounted() {
    // this.getHolidayList();
    console.log(sessionStorage["onlinestate"]);
  },
  methods: {
    checkForm(data, tab) {
      if (tab == "En_name") {
        this.form1.name = data
          .replace(/[^A-Za-z|\s*]+/g, "")
          .replace(/\s+/g, " ")
          .replace(/(^\s*)/g, "");
      } else if (tab == "Cn_name") {
        this.form1.name = data
          .replace(/[^\u4e00-\u9fa5]+/g, "")
          .replace(/(^\s*)/g, "");
      }
    },
    codeFn() {
      let _this = this;
      if (!Object.is(_this.$t("login.yanzhengma"), _this.form1.codeIndex)) {
        return;
      }
      _this.$refs["form1"].validateField("phone", (valid) => {
        if (!valid) {
          https
            .fetchLoginPost(apiUrl.getVerificationCode, {
              nationcode: _this.form1.nationcode,
              phonenum: _this.form1.phone,
              language: _this.$i18n.locale,
            })
            .then((data) => {
              if (Object.is(data.qmiscode, 1000)) {
                App.oTool.successT(data.qmismsg, 2000);
                _this.form1.codeIndex = 60;
                let timer = setInterval(() => {
                  if (_this.form1.codeIndex <= 1) {
                    _this.form1.codeIndex = _this.$t("login.yanzhengma");
                    clearInterval(timer);
                    return;
                  }
                  _this.form1.codeIndex--;
                }, 1000);
              } else {
                App.oTool.warningT(data.qmismsg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      });
    },
    messLoad() {
      let _this = this;
      let json = {
        token: _this.$store.state.token,
      };
      https
        .fetchLoginPost(apiUrl.getYuYueTimeList, {
          // token: json.token,
          language: localStorage.getItem("lang"),
          date:
            _this.datetime.getFullYear() +
            "-" +
            (_this.datetime.getMonth() + 1) +
            "-" +
            _this.datetime.getDate(),
        })
        .then((data) => {
          if (Object.is(data.qmiscode, 1000)) {
            _this.timeList = data.timeList;
            _this.form1.yuyuetime = null;
          } else if (
            Object.is(data.qmiscode, 3000) ||
            Object.is(data.qmiscode, 2000)
          ) {
            // _this.$refs["Messwarn"].SendMessage(data.qmismsg);
            this.$message({
              message: data.qmismsg,
              type: 'warning'
            });
            setTimeout(() => {
              location.href = this.$store.state.urlapi;
            }, 1500);
          } else {
            // _this.$refs["Messwarn"].SendMessage(data.qmismsg);
            this.$message({
              message: data.qmismsg,
              type: 'warning'
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    disabledDate(time) {
      console.log(time);
      return (
        time.getDay() == 0 ||
        time.getDay() == 6 ||
        time.getTime() < Date.now() ||
        time.getTime() > Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
        this.jiejiari.indexOf(
          time.getFullYear() +
            "-" +
            (time.getMonth() + 1) +
            "-" +
            time.getDate()
        ) >= 0
      );
    },
    renderContent(h, parmas) {
      const loop = (data) => {
        var _this = this;
        const vdate = data.defdate;
        if (
          _this.datetime.getFullYear() +
            "-" +
            (_this.datetime.getMonth() + 1) +
            "-" +
            _this.datetime.getDate() !=
          vdate.getFullYear() +
            "-" +
            (vdate.getMonth() + 1) +
            "-" +
            vdate.getDate()
        ) {
          if (
            _this.jiejiari.indexOf(
              vdate.getFullYear() +
                "-" +
                (vdate.getMonth() + 1) +
                "-" +
                vdate.getDate()
            ) >= 0 
          ) {
            console.log(this.websta);
            if (this.websta == "ipad") {
              return (
                <p class="canda gaod">
                  {" "}
                  {data.defdate.getDate()} <div id="warp_img3"></div>{" "}
                </p>
              );
            } else if (this.websta == "pc") {
              return (
                <p class="canda gaod">
                  {" "}
                  {data.defdate.getDate()} <div id="warp_img"></div>{" "}
                </p>
              );
            } else {
              return (
                <p class="canda gaod">
                  {" "}
                  {data.defdate.getDate()} <div id="warp_img2"></div>{" "}
                </p>
              );
            }
            //<span class="jierix" style="color:red;font-size:30px;position: absolute;left: 4.1rem;top: 0.54rem;">.</span>
          } else {
            return <p class="canda gaod"> {data.defdate.getDate()} </p>;
          }
        } else {
          return (
            <p class="selected gaod">
              {" "}
              {data.defdate.getDate()} <i class="el-icon-alarm-clock"> </i>{" "}
            </p>
          );
        }
      };
      return <div class="itemcand"> {loop(parmas)} </div>;
    },
    dateselect(vdate) {
      var _this = this;
      if (
        _this.datetime.getFullYear() +
          "-" +
          (_this.datetime.getMonth() + 1) +
          "-" +
          _this.datetime.getDate() !=
        vdate.getFullYear() +
          "-" +
          (vdate.getMonth() + 1) +
          "-" +
          vdate.getDate()
      ) {
        _this.datetime = vdate;
      }
      this.messLoad();
    },
    kx(time) {
      this.candate = this.datetime;
      this.form1.yuyuetime = time;
      this.$refs["form2"].validate();
    },
    xx(time, state) {
      this.candate = this.datetime;
      // if (state == 2) {
      // 	this.$refs['Messwarn'].SendMessage(time + this.$t('allpage.xiuxintime'))
      // } else {
      // 	this.$refs['Messwarn'].SendMessage(time + this.$t('allpage.yuyuesize'))
      // }
    },
    nextFn() {
      let _this = this;
      let message = _this.$t("login.khname");
      // if (_this.websta == "phone") {
      //   message = _this.$t("model.messagemin");
      // }
      _this.$refs["form2"].validate((valid) => {
        if (valid) {
          _this.$refs["form1"].validate((valid) => {
            if (valid) {
              // let json = {
              // 	token: _this.$store.state.token,
              // }
              // token: json.token,
              https
                .fetchLoginPost(apiUrl.newWebYuyue, {
                  language: localStorage.getItem("lang"),
                  type: "1",
                  phonenum: _this.form1.phone,
                  nationcode: _this.form1.nationcode, //区号
                  language: _this.$i18n.locale,
                  name: _this.form1.name,
                  email: _this.form1.email,
                  captcha: _this.form1.captcha, //验证码
                  time: _this.form1.yuyuetime,
                  date:
                    _this.datetime.getFullYear() +
                    "-" +
                    (_this.datetime.getMonth() + 1) +
                    "-" +
                    _this.datetime.getDate(),
                })
                .then((data) => {
                  if (Object.is(data.qmiscode, 1000)) {
                    console.log(data);
                    // _this.$router.push({
                    //   path: "/main/finish_cg",
                    // });
                    this.$router.push({
                      path: 'finish_cg',
                      query:{
                          progress:data.progress,
                          lang:this.$route.query.lang,
                        }
                    });
                    // } else if (Object.is(data.qmiscode, 3000) || Object.is(data
                    // 		.qmiscode, 2000)) {
                    // 	_this.$refs['Messwarn'].SendMessage(data.qmismsg)
                    // 	setTimeout(() => {
                    // 		location.href = this.$store.state.urlapi
                    // 	}, 1500);
                  } else if (data.qmiscode == 1001) {
                    // _this.$refs["Messwarn"].SendMessage(data.qmismsg);
                    this.$message({
                      message: data.qmismsg,
                      type: 'warning'
                    });
                    // _this.$router.push({
                    //   path: 'finish_cg',
                    //   query:{
                    //       progress:1001,
                    //       text:'123123',

                    //     }
                    // });
                  } else {
                    // _this.$refs["Messwarn"].SendMessage(data.qmismsg);
                    this.$message({
                      message: data.qmismsg,
                      type: 'warning'
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              // _this.$refs["Messwarn"].SendMessage(message);
              this.$message({
                message: message,
                type: 'warning'
              });
              
              // App.oTool.warningT(_this.$t('login.khname'))
            }
          });
        } else {
          // _this.$refs["Messwarn"].SendMessage(message);
           this.$message({
              message: message,
              type: 'warning'
            });
        }
      });
    },
  },
};
</script>
